import axios from 'axios'
import { Identifier } from 'react-admin'

export function getUserELDAvailableTime(driver_id: Identifier) {
  const url = `/api/v1/console/compliance-eld/${driver_id}/available-time/`
  return axios.get(url)
}

export function getUserELDConnectednessErrors(driver_id: Identifier) {
  const url = `/api/v1/console/compliance-eld/${driver_id}/connection-issues/`
  return axios.get(url)
}
